import React from 'react'
import { Outlet } from 'react-router-dom'

import { Page } from '../../../components/layouts/page'
import { SideBar } from '../../../components/layouts/sidebar'
import { Icon } from '../../../components/icons'
import { Path } from '../../../router/paths'

// eslint-disable-next-line import/order
import { Megaphone, TableOfContents } from 'lucide-react'

export const AdminSettingsLayout = () => {
  return (
    <>
      <Page.Content
        className=""
        style={{
          marginTop: 80,
          marginLeft: 80,
          marginRight: 10,
          marginBottom: 500,
        }}
      >
        <Outlet />
      </Page.Content>

      <Page.SideBar>
        <SideBar.Root>
          <SideBar.List>
            <SideBar.Item title={'Informações'} link={Path.ASettings}>
              <Icon size={30}>info</Icon>
            </SideBar.Item>
            <SideBar.Item title={'Usuarios'} link={Path.AdminUsers}>
              <Icon size={30}>users</Icon>
            </SideBar.Item>
            <SideBar.Item title={'Setores'} link={Path.AdminSectors}>
              <Icon size={30}>sectors</Icon>
            </SideBar.Item>
            {/* <SideBar.Item title={'Planos'} link={Path.AdminPlans}>
              <Icon size={30}>bill</Icon>
            </SideBar.Item> */}
            <SideBar.Item title={'Documentos'} link={Path.AdminDocuments}>
              <Icon size={30}>doc</Icon>
            </SideBar.Item>
            <SideBar.Item title={'Consentimentos'} link={Path.AdminConsents}>
              <Icon size={30}>file-check</Icon>
            </SideBar.Item>
            <SideBar.Item title={'Cargos'} link={Path.AdminCargos}>
              <Icon size={30}>job</Icon>
            </SideBar.Item>
            <SideBar.Item title={'Avisos'} link={Path.AdminNotices}>
              <Megaphone />
            </SideBar.Item>
            <SideBar.Item title={'Relatórios'} link={Path.AdminReports}>
              <Icon size={30}>list</Icon>
            </SideBar.Item>
            <SideBar.Item title={'Motivos'} link={Path.AdminReasons}>
              <TableOfContents size={30} />
            </SideBar.Item>
            {/* <SideBar.Item title={'Documentação'} link={Path.AdminDocumentation}>
              <Book size={30} />
            </SideBar.Item> */}
            <SideBar.Item title={'Logs do Sistema'} link={Path.AdminLogSystem}>
              <Icon size={30}>health</Icon>
            </SideBar.Item>
          </SideBar.List>
        </SideBar.Root>
      </Page.SideBar>

      {/* Componente do REACT DOM que move a pagina para cima ao trocar de paginas, só funciona para as paginas que estão em children  */}
    </>
  )
}
